<template>
  <div class="register">
    <BackHome title="修改密码" />
    <div class="content">
      <div class="tips1">修改须知：</div>
      <div class="tips2">
        若您的账号绑定手机无法接受验证码，请点击<span
          @click="forgot"
          style="color: #cd3232; cursor: pointer"
          >上传手持证件照</span
        >来修改密码。
      </div>
      <a-input
        placeholder="请输入您的证件号码"
        v-model="params.idcard"
        :maxLength="18"
        class="input-common"
      />
      <a-input
        placeholder="请输入手机号"
        v-model="params.phone"
        :maxLength="11"
        class="input-common"
      />
      <div class="code">
        <a-input
          placeholder="请输入图片验证码"
          :maxLength="4"
          v-model="params.captcha"
          class="input-code"
        />
        <img
          :src="imageCode"
          alt=""
          @click="getCaptchaCode"
          class="imageCode"
        />
      </div>
      <div class="code">
        <a-input
          placeholder="请输入验证码"
          :maxLength="4"
          v-model="params.code"
          class="input-code"
        />
        <div
          :class="{
            'send-code': true,
            'disabled-btn': timerCount,
          }"
          @click="sendCode"
        >
          {{ codeText }}
        </div>
      </div>
      <a-input-password
        placeholder="请输入密码"
        v-model="params.password"
        class="input-common"
        style="margin-bottom: 10px"
      />
      <div
        class="input-common"
        style="color: #333333; text-align: left; height: auto"
      >
        密码须由8-16位数字、字母或符号组成，不可为纯数字
      </div>
      <a-input-password
        placeholder="请再次输入密码"
        v-model="params.password2"
        class="input-common"
      />
      <div class="button" @click="submit">提交</div>
      <div class="bottom">
        <div class="left" @click="gotoLogin">←返回登录页</div>
      </div>
    </div>
  </div>
</template>

<script>
import BackHome from "@/components/common/BackHome.vue";
import { isTel, isPassword } from "@/utils/validate";
import { uuid } from "vue-uuid";

export default {
  components: {
    BackHome,
  },
  data() {
    return {
      params: {
        idcard: "",
        phone: "",
        password: "",

        uuid: "", // 随机生成，用于获取图形验证码并验证
        captcha: "",
        code: "",
        password2: "",
      },

      imageCode: "", // 图形验证码url
      imageCodeLoading: false, // 图形验证码获取ing

      flag: false,
      timerCount: 0,
      codeTimer: null,
      loading: false,
    };
  },
  computed: {
    codeText() {
      return this.timerCount == 0 ? "获取验证码" : this.timerCount + "(S)";
    },
  },
  created() {
    // this.$EventBus.$emit('showMenu', false);
  },
  mounted() {
    this.getCaptchaCode();
  },
  methods: {
    // 获取手机验证码
    sendCode() {
      // 正在请求
      if (this.flag) return;
      // 倒计时未结束
      if (this.timerCount) return;
      // 判断手机号
      if (!isTel(this.params.phone)) {
        this.$message.error("请输入合法的手机号码");
        return;
      }
      if (!this.params.captcha || this.params.captcha.length != 4) {
        this.$message.error("请输入完整的图形验证码");
        return;
      }
      // 开始请求
      this.flag = true;
      this.$api.vmsapi
        .sendCode({
          tel: this.params.phone,
          type: "1",
          id: this.params.uuid,
          code: this.params.captcha,
        })
        .then(() => {
          this.$message.success("验证码发送成功");
          this.timerCount = 60;
          this.codeTimer = setInterval(() => {
            this.timerCount--;
            if (this.timerCount <= 0) {
              this.timerCount = 0;
              clearInterval(this.codeTimer);
            }
          }, 1000);
        })
        .finally(() => {
          this.flag = false;
        });
    },
    // 提交
    submit() {
      if (this.loading) return;
      if (!this.params.idcard) {
        this.$message.error("请输入证件号码");
        return;
      }
      if (!isTel(this.params.phone)) {
        this.$message.error("请输入合法的手机号码");
        return;
      }
      if (!this.params.captcha || this.params.captcha.length != 4) {
        this.$message.error("请输入完整的图形验证码");
        return;
      }
      if (!this.params.code || this.params.code.length != 4) {
        this.$message.error("请输入完整的短信验证码");
        return;
      }
      if (!isPassword(this.params.password)) {
        this.$message.error("请输入符合规则的密码");
        return;
      }
      if (this.params.password !== this.params.password2) {
        this.$message.error("两次输入的密码不一致");
        return;
      }
      this.verfiyCode();
    },
    // 验证短信
    verfiyCode() {
      this.loading = true;
      this.$api.vmsapi
        .checkCode({
          tel: this.params.phone,
          type: "1",
          code: this.params.code,
        })
        .then(() => {
          this.forgotRequest();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 请求
    forgotRequest() {
      const params = {
        idcard: this.params.idcard,
        password: this.params.password,
      };
      this.$api.vmsapi
        .forgetPassword(params)
        .then(() => {
          this.countDown();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 获取图形验证码
    getCaptchaCode() {
      if (this.imageCodeLoading) return;
      this.imageCodeLoading = true;
      this.params.uuid = uuid.v1();
      this.$api.vmsapi
        .imageCode({ id: this.params.uuid })
        .then((res) => {
          this.imageCode = res.image;
        })
        .finally(() => {
          this.imageCodeLoading = false;
          this.params.captcha = "";
        });
    },

    gotoLogin() {
      this.$router.replace({ name: "login" });
    },
    forgot() {
      this.$router.push({ name: "forgot2" });
    },
    countDown() {
      let secondsToGo = 5;
      const modal = this.$success({
        title: "修改成功！",
        content: `${secondsToGo}s后前往登录页`,
        closable: true,
        okText: "确定",
        onCancel: () => {
          this.gotoLogin();
        },
        onOk: () => {
          this.gotoLogin();
        },
      });
      const interval = setInterval(() => {
        secondsToGo -= 1;
        modal.update({
          content: `${secondsToGo}s后前往登录页`,
        });
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        modal.destroy();
        this.gotoLogin();
      }, secondsToGo * 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.register {
  width: 770px;
  margin: 0 auto;
  margin-bottom: 100px;
  
  .content {
    background-color: #ffffff;
    padding: 50px 180px 80px;
    width: 100%;

    .tips1 {
      font-size: 14px;
      font-family: Helvetica;
      color: #333333;
      line-height: 14px;
      margin-bottom: 15px;
      text-align: left;
    }

    .tips2 {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      margin-bottom: 20px;
      text-align: left;
    }

    .button {
      height: 36px;
      background: #cd3232;
      border-radius: 2px;
      margin-bottom: 20px;
      cursor: pointer;

      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Helvetica;
      color: #ffffff;
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #cd3232;
        cursor: pointer;
      }
    }

    .input-common {
      margin-bottom: 20px;
      font-size: 14px;
      font-family: Helvetica;
      height: 36px;
    }

    .code {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      font-size: 14px;
      font-family: Helvetica;
    }
    .input-code {
      margin-right: 20px;
      flex: 1;
      height: 36px;
    }

    .imageCode {
      width: 100px;
      height: 36px;
      border-radius: 2px;
      border: 1px solid #bdbdbd;
      cursor: pointer;
    }
    .send-code {
      width: 100px;
      height: 36px;
      background: #cd3232;
      border-radius: 2px;
      line-height: 36px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
    }
    .disabled-btn {
      background-color: #ccc !important;
      cursor: not-allowed;
    }
  }
}
</style>